import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useShopStage } from '@hooks';
import { useAddReferralsToHomePageRecommendation } from '../modules/AddReferralsToHomePageRecommendation';
import { useCampaignRecommendation } from '../modules/CampaignRecommendation';
import { useCartAbandonmentEmailPromoRecommendation } from '../modules/CartAbandonmentEmailPromoRecommendation';
import { useCreateProductRecommendation } from '../modules/CreateProductRecommendation';
import { useCreatorAppRecommendation } from '../modules/CreatorAppRecommendation';
import { useCustomDomainRecommendation } from '../modules/CustomDomainRecommendation';
import { useDigitalProductRecommendation } from '../modules/DigitalProductRecommendation';
import { useFreeShippingRecommendation } from '../modules/FreeShippingRecommendation/hooks/useFreeShippingRecommendation';
import { useGoogleAnalyticsRecommendation } from '../modules/GoogleAnalyticsRecommendation';
import { useHomeProductsRecommendation } from '../modules/HomeProductsRecommendation';
import { useIntegrationsRecommendation } from '../modules/IntegrationsRecommendation';
import { useInviteTeamRecommendation } from '../modules/InviteTeamRecommendation';
import { useMembershipsRecommendation } from '../modules/MembershipsRecommendation';
import { useOrderSamplesRecommendation } from '../modules/OrderSamplesRecommendation/hooks/useOrderSamplesRecommendation';
import { usePayoutsRecommendation } from '../modules/PayoutsRecommendation';
import { useReferralRecommendation } from '../modules/ReferralRecommendation';
import { useTwitchGiftingRecommendation } from '../modules/TwitchGiftingRecommendation';
import { useTwitchPromotionRecommendation } from '../modules/TwitchPromotionRecommendation';
export const useRecommendations = () => {
    const { cartAbandonmentEmailPromoRecommendation } = useCartAbandonmentEmailPromoRecommendation();
    const { addReferralLinkToHomepageRecommendation } = useAddReferralsToHomePageRecommendation();
    const { homeProductsRecommendation } = useHomeProductsRecommendation();
    const { createProductRecommendation } = useCreateProductRecommendation();
    const { orderSamplesRecommendation } = useOrderSamplesRecommendation();
    const { integrationsRecommendation } = useIntegrationsRecommendation();
    const { twitchPromotionRecommendation } = useTwitchPromotionRecommendation();
    const { freeShippingRecommendation } = useFreeShippingRecommendation();
    const { customDomainRecommendation } = useCustomDomainRecommendation();
    const { googleAnalyticsRecommendation } = useGoogleAnalyticsRecommendation();
    const { payoutsRecommendation } = usePayoutsRecommendation();
    const { referralRecommendation } = useReferralRecommendation();
    const { inviteTeamRecommendation } = useInviteTeamRecommendation();
    const { creatorAppRecommendation } = useCreatorAppRecommendation();
    const { twitchGiftingRecommendation } = useTwitchGiftingRecommendation();
    const { digitalProductRecommendation } = useDigitalProductRecommendation();
    const { membershipsRecommendation } = useMembershipsRecommendation();
    const { campaignRecommendation } = useCampaignRecommendation();
    const { shopStage } = useShopStage();
    useEffect(() => {
        if (shopStage.currentStage) {
            TagManager.dataLayer({ dataLayer: { shopStage: shopStage.currentStage } });
        }
    }, [shopStage.currentStage]);
    const recommendations = [
        campaignRecommendation,
        homeProductsRecommendation,
        createProductRecommendation,
        orderSamplesRecommendation,
        integrationsRecommendation,
        twitchPromotionRecommendation,
        addReferralLinkToHomepageRecommendation,
        freeShippingRecommendation,
        cartAbandonmentEmailPromoRecommendation,
        customDomainRecommendation,
        googleAnalyticsRecommendation,
        payoutsRecommendation,
        referralRecommendation,
        inviteTeamRecommendation,
        creatorAppRecommendation,
        twitchGiftingRecommendation,
        digitalProductRecommendation,
        membershipsRecommendation,
    ];
    const isLoadingRecommendations = recommendations.some(({ isLoading }) => isLoading);
    const enabledRecommendations = (() => {
        return recommendations.filter(({ enabled }) => enabled);
    })();
    return { recommendations: !isLoadingRecommendations ? enabledRecommendations : undefined };
};
